import React, { Component } from "react";
import "./Service.scss";

class Service extends Component {
  render() {
    return (
      <div className="CustomContainer">
        <a href="tel:15999964">
          <div className="TextBox">
            <div className="Title">대표번호</div>
            <div className="Tell">1599-9964</div>
            <div className="TellBox">FAX. 02. 517. 1493</div>
          </div>
        </a>
      </div>
    );
  }
}

export default Service;
